// import components
import {
  Box,
  BoxProps,
  IconButton,
  IconButtonProps,
  styled,
  TypographyProps
} from '@mui/material';
import { StyledTypographyLineClamped } from 'components/shared/Typography/Typography.styles';

export const StyledCapitalizeTypography = styled(
  StyledTypographyLineClamped
)<TypographyProps>(() => ({
  textTransform: 'capitalize'
}));

export const StyledMediumIconButton = styled(IconButton)<IconButtonProps>(
  () => ({
    width: '32px',
    height: '32px'
  })
);

export const StyledTooltipContainer = styled(Box)<BoxProps>(({ theme }) => ({
  padding: theme.spacing(2)
}));

export const StyledCustomCapTypography = styled(
  StyledCapitalizeTypography
)<TypographyProps>(({ theme }) => ({
  lineHeight: theme.typography.body2.lineHeight
}));

export const StyledNoteNameAndDateBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCompact'
})<BoxProps & { isCompact?: boolean }>(({ theme, isCompact = false }) => ({
  display: 'flex',
  flexDirection: isCompact ? 'row' : 'column',
  alignItems: isCompact ? 'center' : 'flex-start',
  gap: isCompact ? theme.spacing(2) : 0
}));
